const postalCodeTypes = {
  LOGRADOURO: 'POSTAL_CODE_TYPE_ADDRESS',
  LOCALIDADE: 'POSTAL_CODE_TYPE_LOCALITY',
  GRANDE_USUARIO: 'POSTAL_CODE_TYPE_HUGE_USER',
  CAIXA_POSTAL_COMUNITARIA: 'POSTAL_CODE_TYPE_COMMUNITY_MAILBOX',
  UNIDADE_OPERACIONAL_CORREIOS: 'POSTAL_CODE_TYPE_OPERATIONAL_UNITY'
};

export default postalCodeTypes;
